<template>
    <div class="d-flex flex-row" style="width: 50rem">
        <div
            v-lazy-container="{ selector: 'img' }"
            class="d-flex flex-column justify-content-center align-items-center pt-0 p-5"
        >
            <img
                data-src="/logo/iRender-fulltext.svg"
                alt=""
                style="width: 5rem"
            />
            <img
                class="mt-3"
                data-src="/image/fixed-rental/fixed-rental-bg.svg"
                alt=""
                style="width: 17.5rem"
            />
        </div>
        <div
            class="d-flex flex-column p-2 pl-10 pr-5"
            style="border-left: 1px solid #eeeeee"
        >
            <div
                style="
                    font-size: 0.95rem;
                    color: #42a5f5;
                    font-family: Montserrat;
                    font-weight: 600;
                    text-align: center;
                "
            >
                RENTAL PLAN
            </div>
            <div
                class="mt-5"
                style="
                    font-family: Montserrat;
                    text-align: justify;
                    font-size: 0.7rem;
                "
            >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" To help clients with big
                projects and long-time rendering, we have established Rental
                Plan feature, so that you can rent the machine(s) on a daily /
                weekly / monthly basis at a cheaper price "
            </div>
            <div class="mt-5" style="font-size: 0.8rem">
                <div style="font-weight: 600">Description:</div>
                <div class="ml-3">
                    <div class="mt-2">
                        •&nbsp;&nbsp;{{ descriptionNoRefund }}
                    </div>
                    <div class="mt-2">•&nbsp;&nbsp;{{ descriptionTime }}</div>
                </div>
                <div class="mt-5" style="font-weight: 600">Requirements:</div>
                <div
                    class="mt-2 ml-3"
                    style="color: #bdbdbd; font-style: italic"
                >
                    No requirements
                </div>
            </div>
            <div class="d-flex justify-content-center mt-10">
                <el-button
                    @click="skipDescription"
                    class="pl-10 pr-10"
                    type="primary"
                    round
                    >Continue<i
                        class="el-icon-arrow-right el-icon-right ml-3"
                    ></i
                ></el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            descriptionTime:
                "The usage time of the device will be calculated from the time you confirm",
            descriptionNoRefund:
                "This feature is non-refundable. Please consider your needs before using",
        };
    },

    methods: {
        skipDescription() {
            this.$emit("processingEvent", {
                event: "skipDescription",
                data: false,
            });
        },
    },
};
</script>